import { Component, Input, inject } from '@angular/core';
import { Router } from '@angular/router';
import { GetRequestListResponseItem } from '@schema/APITypes';

@Component({
  selector: 'lgv-request-link-table-item',
  template: ' @if (data) {<div (click)="onClick()">{{ data.lastName }} {{ data.firstName }}</div>} ',
  styles: [
    `
      :host {
        cursor: pointer;
      }
    `,
  ],
  standalone: false,
})
export class RequestLinkTableItemComponent {
  private router = inject(Router);

  @Input() data: GetRequestListResponseItem;
  @Input() link: string;

  onClick(): void {
    const url = this.router.createUrlTree([this.link.replace(':id', this.data.id)]);
    window.open(url.toString(), '_blank');
  }
}
